import { render } from "./ClassScoreStat.vue?vue&type=template&id=827e52d4&scoped=true"
import script from "./ClassScoreStat.vue?vue&type=script&lang=js"
export * from "./ClassScoreStat.vue?vue&type=script&lang=js"

import "./ClassScoreStat.vue?vue&type=style&index=0&id=827e52d4&scoped=true&lang=css"
import "./ClassScoreStat.vue?vue&type=style&index=1&id=827e52d4&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827e52d4"]])

export default __exports__